import { Box, Spinner } from "@chakra-ui/react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../../Hooks/useAuth";

const GREEN = "#004a33";

// Gatekeeper for every /admin/* route. Renders nothing admin-related — no
// sidebar, no data fetch — until the session is confirmed to belong to an
// admin, closing the gap where the page used to mount and fire its data
// fetch before the auth check had a chance to redirect.
//
// This is a UX/defense-in-depth layer only, not a security boundary: it runs
// in the visitor's own browser, so it protects against someone casually
// opening /admin/dashboard, not against someone calling the API directly.
// The real guarantee has to come from boozen-api checking the session on
// every admin read/write endpoint — see the backend findings reported
// alongside this change.
export function RequireAdmin({ children }) {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated()) {
    return <Navigate to="/sign_in" replace />;
  }

  // `user` is `undefined` while /users/me is still in flight (token present
  // but not yet resolved) and `null` once it's resolved to "not logged in".
  if (user === undefined) {
    return (
      <Box minH="100vh" display="flex" alignItems="center" justifyContent="center">
        <Spinner color={GREEN} thickness="3px" />
      </Box>
    );
  }

  if (!user || user.access !== "admin") {
    return <Navigate to="/" replace />;
  }

  return children;
}
